package us.laantech.common.util

fun String.dollarStringToCents(): Long? {
    val parts = this.trim().split(".")
    val dollars = parts.getOrNull(0)?.toLongOrNull() ?: return null
    val centsStr = parts.getOrNull(1)?.padEnd(2, '0')?.take(2) ?: "00"
    val cents = centsStr.toLongOrNull() ?: return null
    return dollars * 100L + cents
}


fun Long.centsToDollarString(): String {
    val dollars = this / 100
    val cents = this % 100
    return "$dollars.${cents.toString().padStart(2, '0')}"
}